/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SyncSlackDirectoryRequestBody,
  SyncSlackDirectoryRequestBody$Outbound,
  SyncSlackDirectoryRequestBody$outboundSchema,
} from "../components/syncslackdirectoryrequestbody.js";

export type SyncSlackDirectorySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SyncSlackDirectoryRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  syncSlackDirectoryRequestBody: SyncSlackDirectoryRequestBody;
};

/** @internal */
export type SyncSlackDirectorySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SyncSlackDirectorySecurity$outboundSchema: z.ZodMiniType<
  SyncSlackDirectorySecurity$Outbound,
  SyncSlackDirectorySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function syncSlackDirectorySecurityToJSON(
  syncSlackDirectorySecurity: SyncSlackDirectorySecurity,
): string {
  return JSON.stringify(
    SyncSlackDirectorySecurity$outboundSchema.parse(syncSlackDirectorySecurity),
  );
}

/** @internal */
export type SyncSlackDirectoryRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SyncSlackDirectoryRequestBody: SyncSlackDirectoryRequestBody$Outbound;
};

/** @internal */
export const SyncSlackDirectoryRequest$outboundSchema: z.ZodMiniType<
  SyncSlackDirectoryRequest$Outbound,
  SyncSlackDirectoryRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    syncSlackDirectoryRequestBody: SyncSlackDirectoryRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      syncSlackDirectoryRequestBody: "SyncSlackDirectoryRequestBody",
    });
  }),
);

export function syncSlackDirectoryRequestToJSON(
  syncSlackDirectoryRequest: SyncSlackDirectoryRequest,
): string {
  return JSON.stringify(
    SyncSlackDirectoryRequest$outboundSchema.parse(syncSlackDirectoryRequest),
  );
}
